import { gql } from "@apollo/client";

export const GET_PAYEE_CURBPASS_SETTINGS = gql`
  query GetPayeeCurbPassSettings($payeeAccountId: uuid!) {
    payeeCurbPassSettings: payee_curbpass_settings(where: { payee_account_id: { _eq: $payeeAccountId } }) {
      payeeAccountId: payee_account_id
      walletPaymentEnabledAt: wallet_payment_enabled_at
      sessionPaymentEnabledAt: session_payment_enabled_at
      sessionPaymentServiceFeeBasisAmount: session_payment_service_fee_basis_amount
      sessionPaymentServiceFeeRatio: session_payment_service_fee_ratio
      sessionPaymentServiceFeeMaximumAmount: session_payment_service_fee_maximum_amount
    }
  }
`;

export interface GetPayeeCurbPassSettingsVars {
  payeeAccountId: string;
}

export interface PayeeCurbPassSettings {
  payeeAccountId: string;
  walletPaymentEnabledAt: string | null;
  sessionPaymentEnabledAt: string | null;
  sessionPaymentServiceFeeBasisAmount: number;
  sessionPaymentServiceFeeRatio: number;
  sessionPaymentServiceFeeMaximumAmount: number;
}

export interface GetPayeeCurbPassSettingsData {
  payeeCurbPassSettings: PayeeCurbPassSettings[];
}

export default GET_PAYEE_CURBPASS_SETTINGS;
